import React, { useEffect, useState } from 'react';
import axios from 'axios';
import connect from 'react-redux/lib/connect/connect';
import { isEmpty, toastr, getSlotImgPath, getTitle, getlistImgPath, getlistOverImgPath, getImages, getLobbylist, getGameList, getGameLaunch } from '../../common/cores';
import { api_url } from '../../common/cores/keys';
import { SetPageLoading } from '../../common/actions/pageAction';
import { logoutUser } from '../../common/actions/userActions';

const SlotCenter = (props) => {

    const { type, casinoStatus } = props;
    const [lists, setLists] = useState([]);
    const [gameLists, setGameLists] = useState([]);
    const [imgLists, setImgLists] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    // const [api, setApi] = useState("lobby");

    const [ search, setSearch ] = useState("");

    const onChange = (e) =>{
        const { name, value } = e.target;
        setSearch(value);
    }

    const getLists = () => {
        const { type } = props;
        props.SetPageLoading(true);
        const params = {
            type: type,
            token: props.user.data.loginId,
            username: props.user.data.loginId,
            status: casinoStatus
        }
        getLobbylist(params).then(data => {
            // setApi(data.api);
            setLists(data.lobbyList);
            props.SetPageLoading(false);
        })
    }

    const onClickOpenModal = (list) => {
        const { type } = props;
        if (!props.user.isAuthenticated)
            return toastr.warning("로그인하시고 이용해주세요.");
        props.SetPageLoading(true);
        setGameLists([]);
        const params = {
            ...list,
            type: type,
            username: props.user.data.loginId,
            vendor: list.vendor,
            // api: api
        }

        getGameList(params).then(data => {
            // setApi(data.api);
            getImages(data.result, data.api)
                .then((images) => {
                    setImgLists(images);
                    setGameLists(data.result);
                setOpenModal(!openModal);
                props.SetPageLoading(false);
                });
            
        })
    }

    const onClickCloseModal = (list) => {
        // console.log(list);
        setOpenModal(!openModal );
    }

    const onClickList = (list) => {
        props.SetPageLoading(true);
        // console.log(localStorage);
        const params = {
            ...list,
            type: type,
            username: props.user.data.loginId,
            ipADD: localStorage.getItem('client-ip') 
        }
        getGameLaunch(params);
    }

    useEffect(() => {
        if(props.isAuthenticated && !isEmpty(props.user))
           getLists();
    },[props.isAuthenticated]);

    
    
    const normalImage = "AstiLogo.jpg";
    const modalImage = "AstiLogo_.jpg";

    const getNormalImg = (e) =>{
        // console.log(e.target.src);
        e.target.src=`../images/${type}/${normalImage}`
    }
    
    const getNormalOverImg = (e) =>{
        // e.target.src=`../images/${type}/${normalImage}`
        e.target.style.display = "none";
    }

    const getModalImg = (e) =>{
        // console.log(e.target.src);
        e.target.src=`../images/${type}/${normalImage}`
    }

    return (
        <div className="contents_box">
            <div className="game_list slot_list">
                <ul className="">
                    {
                        lists.map((list, index) => {
                            return (
                                <li key={index} style={{ padding: "20px_" }}>
                                    <a className="slot_img_div" onClick={ type === "Slot" ? () => onClickOpenModal(list) : () => onClickList(list) }>
                                        <img data-v-3348b8aa="" className="slot_list_img lobby-list-ratio" src={getlistImgPath(list)} alt="" style={{ borderRadius: "0%" }} onError={getNormalImg}/>
                                        <img data-v-3348b8aa="" className="slot_list_over_img lobby-list-ratio" src={getlistOverImgPath(list)} alt="" style={{ borderRadius: "0%" }} onError={getNormalOverImg}/>
                                    </a>
                                    <p className="text-center">{getTitle(list)}</p>
                                </li>
                            )
                        })
                    }
                </ul>
            </div>
            <div className=" align-items-center  justify-content-center slot-modal-back" style={{ display: !openModal ? "none" : "flex" }}>
                <div className="justify-content-center slot-modal game_list" style={{ listStyleType:"none"}}>
                    <button data-v-57fde08a="" className="btn_close" onClick={onClickCloseModal}>
                        <i data-v-57fde08a="" className="fa-light fa-close font-weight-light align-items-center justify-content-center color-white font-size-26 btn-close" style={{fontStyle:"normal"}}></i>
                    </button>
                    <div className="slot-search ">
                        {/* <label className="slot-search-label">검색</label> */}
                        <input className="slot-search-input " 
                            name="search" type="text" 
                            placeholder="검색"
                            value={search} onChange={onChange}/>
                    </div>
                    <div className="w-100 h-100 overflow-auto">
                        <ul className="slot_list justify-content-center flex-wrap" style={{ width: "100%" }}>
                            {
                                gameLists.filter(list => { const patt = new RegExp(search, "i"); return patt.test(getTitle(list)) || isEmpty(search); }).map((list, index) => {
                                    const imgIndex = imgLists.findIndex(img => img.src === list.image); 
                                    return (
                                        <li key={index} style={{ listStyleType:"none",marginBottom: "30px_" }}>
                                            <a style={{backgroundColor:"#0f1621"}} onClick={() => onClickList(list)}>
                                                <img data-v-3348b8aa="" className="slot-default-img" src={imgLists[imgIndex].src} alt="" style={{ borderRadius: "10%", minWidth: "145px_" }} onError={getModalImg}/>
                                            </a>
                                            <p className="text-center" style={{ color: "white" }}>{getTitle(list)}</p>
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};
const mapStateToProps = state => ({
    isAuthenticated: state.user.isAuthenticated,
    user: state.user,
    page: state.page
});

export default connect(mapStateToProps,{ SetPageLoading, logoutUser })(SlotCenter);


// WEBPACK FOOTER //
// ./src/components/Slot/SlotCenter.js